/* eslint-disable sort-keys-fix/sort-keys-fix */
import base from "./base"
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/substation/"

const SUBSTATION: CommunityData = {
  code: "substation",
  inviteCode: "substation",
  name: "Substation",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/sta-030`,
  waitlist: false,
  socials: {},
  styles: {
    ...base.styles,
    comingSoon: {
      bgColor: "#462680",
      hero: {
        desktop: `${S3_PREFIX}web-background-non-member.jpg`,
        mobile: `${S3_PREFIX}web-background-non-member.jpg`,
        style: "bg-[#462680]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-alternative-logo.png`,
        mobile: `${S3_PREFIX}web-alternative-logo.png`,
        style: "w-[120px] h-[66px] sm:w-[174px] sm:h-[94px]",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['OxaniumBold'] text-[28px] leading-[120%] uppercase text-[#ffffff]",
      text: "font-['InterRegular'] text-[16px] leading-[120%] text-[#ffffff]",
      button:
        "font-['InterRegular'] text-[16px] leading-[100%] p-4 bg-[#ffffff] text-[#462680] cursor-pointer w-fit rounded-lg",
      input: {
        base: "font-['InterRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#462680] text-[#ffffff] rounded-lg",
        border: "#eb661c",
        borderFocus: "#ffffff",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['InterRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['InterRegular'] text-[12px] leading-[120%] text-[#ffffff]",
      skipButton: "font-['InterRegular'] text-[14px] leading-[120%] text-[#ffffff] cursor-pointer",
      modal: {
        container: "bg-[#462680] px-[40px] py-[48px] rounded-lg",
        title:
          "font-['OxaniumBold'] text-[24px] leading-[120%] uppercase text-[#ffffff] text-center",
        text: "font-['InterRegular'] text-[14px] leading-[120%] text-[#ffffff] text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#462680] font-['InterRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#eb661c",
        otpBorderFocus: "#ffffff",
      },
    },
    global: {
      counterColor: "#ffffff",
      logo: {
        src: "https://media.werz.at/community/icon/cmoacdari00009kmtdqhcpav5.jpg?uploadTime=1776929508115&type=image",
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[170px] h-[94px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      werzLogoColor: "#FFFFFF",
      bgColor: "#462680",
      asideBg: "#462680",
      asideStyles: "",
      contentBg: "",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['InterRegular']",
      primaryButton:
        "bg-[#ffffff] border border-[#ffffff] rounded-lg px-[18px] py-[18px] !text-[#462680] font-['InterRegular'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#eb661c]",
      separator: "border-[#eb661c]",
      item: "font-['OxaniumMedium'] text-[16px] text-[#ffffff] text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#eb661c] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#462680] rounded-lg !pb-8",
      titles: "text-[#ffffff] font-['OxaniumBold'] text-[28px] uppercase text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#eb661c]",
        sectionTitle:
          "text-[#ffffff] font-['OxaniumBold'] text-[28px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden !bg-[#462680]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative rounded-lg overflow-hidden",
          media: "w-full !aspect-square object-cover rounded-lg",
          placeholderMedia: "w-full !aspect-square bg-gray-400 rounded-lg",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ffffff] font-['OxaniumBold'] text-[20px] uppercase text-left leading-[120%]",
          subtitle:
            "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#eb661c]",
        sectionTitle:
          "text-[#ffffff] font-['OxaniumBold'] text-[28px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden !bg-[#462680]",
          mediaContainer:
            "w-full sm:!w-[228px] sm:flex-shrink-0 relative rounded-lg overflow-hidden",
          media: "w-full !aspect-video object-cover rounded-lg",
          placeholderMedia: "w-full !aspect-video bg-gray-400 rounded-lg",
          content: "flex flex-col px-4 bg-transparent",
          title:
            "text-[#ffffff] font-['OxaniumBold'] text-[16px] uppercase text-left leading-[120%]",
          subtitle:
            "text-[#ffffff] font-['InterRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['InterRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#ffffff] font-['InterRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffffff] font-['OxaniumBold'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['OxaniumBold'] text-[28px] uppercase text-left leading-[120%] !mb-4 sm:mb-6",
      },
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/substation/web-background-non-member.jpg",
      bgMobile: "https://media.werz.at/community-assets/substation/web-background-non-member.jpg",
      bgColor: "#462680",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#462680]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#ffffff]",
        name: "text-[#ffffff] font-['OxaniumBold'] text-[28px] uppercase leading-[33.6px] text-center text-center mt-4 mb-1",
        location:
          "font-['OxaniumBold'] uppercase leading-[21.6px] text-[16px] text-center text-center mb-2",
        description:
          "text-[#ffffff] font-['InterRegular'] text-[16px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#ffffff",
        button:
          "bg-[#462680] border border-[#ffffff] rounded-lg px-[16px] py-[12px] text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#462680] border border-[#ffffff] rounded-lg text-[#ffffff] font-['InterRegular'] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#462680] border border-[#ffffff] rounded-lg",
          title:
            "font-['OxaniumBold'] uppercase leading-[21.6px] text-[16px] text-left text-center mb-1",
          text: "text-[#ffffff] font-['InterRegular'] text-[16px] leading-[120%] text-center text-center",
          button:
            "bg-[#462680] border border-[#ffffff] rounded-lg px-[16px] py-[12px] text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[21.6px] text-[16px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#462680] border border-[#ffffff] rounded-lg",
          duration: "text-[#ffffff] font-['InterRegular'] text-[12px] leading-[14.4px] text-left",
          name: "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[21.6px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#ffffff",
          media: "overflow-hidden m-2 border border-[#ffffff] rounded-lg",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[95vw] bg-[#462680] border border-[#ffffff] rounded-lg",
          name: "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[21.6px] text-[16px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#eb661c] border border-[#eb661c] rounded-[8px] text-[#ffffff] font-['OxaniumBold'] text-[16px] uppercase leading-[19.2px] text-center",
          duration: "text-[#ffffff] font-['InterRegular'] text-[12px] leading-[14.4px] text-left",
          location: "text-[#ffffff] font-['InterRegular'] text-[12px] leading-[14.4px] text-left",
          button:
            "bg-[#462680] border border-[#ffffff] rounded-lg px-[16px] py-[12px] text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#ffffff]",
            name: "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[19.2px] text-[14px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price:
              "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[19.2px] text-[14px] text-left",
            link: "text-[#ffffff] font-['InterRegular'] text-[14px] leading-[16.8px] text-left",
            status:
              "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[120%] text-[14px] text-left",
            button:
              "bg-[#462680] border border-[#ffffff] rounded-lg px-[16px] py-[12px] text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[100%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['InterRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#462680] border border-[#ffffff] rounded-lg text-[#ffffff] font-['InterRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[21.6px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#462680] border border-[#ffffff] rounded-lg",
          name: "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[21.6px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#ffffff",
          created: "text-[#ffffff] font-['InterRegular'] text-[12px] leading-[14.4px] text-left",
          media: "overflow-hidden m-2 border border-[#ffffff] rounded-lg",
        },
        seeAllNews:
          "text-[#ffffff] font-['InterRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#462680] border border-[#ffffff] rounded-lg text-[#ffffff] font-['InterRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[21.6px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#462680] border border-[#ffffff] rounded-lg",
          coverUrl: "overflow-hidden m-2 border border-[#ffffff] rounded-lg",
          duration: "text-[#ffffff] font-['InterRegular'] text-[12px] leading-[14.4px] text-left",
          liveType: "text-[#ffffff] font-['InterRegular'] text-[12px] leading-[14.4px] text-left",
          liveTypeCircle: "w-2 h-2 bg-[#ffffff] rounded-full",
          playIconColor: "#ffffff",
          start: "text-[#ffffff] font-['InterRegular'] text-[12px] leading-[14.4px] text-left",
          title:
            "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[21.6px] text-[16px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#ffffff] font-['InterRegular'] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#462680] border border-[#ffffff] rounded-lg text-[#ffffff] font-['InterRegular'] text-[16px] leading-[120%] text-center",
        header:
          "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[21.6px] text-[16px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#462680] border border-[#ffffff] rounded-lg",
          name: "text-[#ffffff] font-['OxaniumBold'] uppercase leading-[21.6px] text-[16px] text-left",
          triangleIconColor: "#ffffff",
          circleIcon:
            "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#ffffff] rounded-lg",
        },
      },
      footer: {
        WERZlogoColor: "#ffffff",
        text: "text-[#ffffff] font-['InterRegular'] text-[12px] leading-[14.4px] text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#462680] rounded-lg !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#eb661c]",
        media: "sm:!w-[320px] !w-full sm:!h-[180px] !h-[180px] object-cover sm:mb-4 rounded-lg",
        title: "text-[#ffffff] font-['OxaniumBold'] text-[28px] uppercase text-left leading-[120%]",
        subtitle:
          "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border border-[#ffffff] rounded-lg px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 gap-y-[6px] text-[#462680] font-['InterRegular'] !text-[16px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#eb661c]",
        header:
          "text-[#ffffff] font-['OxaniumBold'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#eb661c]",
        header:
          "text-[#ffffff] font-['OxaniumBold'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px] rounded-lg",
        mapPinColor: "#eb661c",
        mapStrokeColor: "#eb661c00",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['OxaniumBold'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['OxaniumBold'] text-[24px] uppercase text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#462680] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#462680] border border-[#ffffff] rounded-lg px-[16px] py-[12px] text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#eb661c] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['OxaniumBold'] text-[16px] uppercase text-left leading-[120%] mb-1",
          description:
            "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#ffffff] font-['OxaniumBold'] text-[16px] uppercase text-left leading-[120%]",
          quantity: "text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[100%]",
          status:
            "text-[#ffffff] font-['OxaniumBold'] text-[16px] uppercase text-left leading-[120%]",
          counterContainer:
            "bg-[#462680] border border-[#ffffff] rounded-lg px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#462680] border border-[#ffffff] rounded-lg px-[16px] py-[12px] text-[#ffffff] font-['InterRegular'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default SUBSTATION
